module.exports = __webpack_public_path__ + "images/emoji/point_left.53867c8fd5677b8a9568.png";